// src/stone/icons/Global.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Global = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M2.333 20c0-9.757 7.91-17.667 17.667-17.667S37.667 10.243 37.667 20 29.757 37.667 20 37.667 2.333 29.757 2.333 20M20 4.333C11.348 4.333 4.333 11.348 4.333 20S11.348 35.667 20 35.667 35.667 28.652 35.667 20 28.652 4.333 20 4.333" }),
      /* @__PURE__ */ jsx("path", { d: "M2.333 20a1 1 0 0 1 1-1h33.334a1 1 0 1 1 0 2H3.333a1 1 0 0 1-1-1" }),
      /* @__PURE__ */ jsx("path", { d: "M20 2.333a1 1 0 0 1 .738.326 26.5 26.5 0 0 1 6.928 17.362 26.5 26.5 0 0 1-6.928 17.32 1 1 0 0 1-1.476 0 26.5 26.5 0 0 1-6.928-17.362 26.5 26.5 0 0 1 6.928-17.32A1 1 0 0 1 20 2.333m0 2.521A24.5 24.5 0 0 0 14.334 20 24.5 24.5 0 0 0 20 35.146 24.5 24.5 0 0 0 25.666 20 24.5 24.5 0 0 0 20 4.854" })
    ]
  }
);
var Global_default = Global;

export {
  Global,
  Global_default
};
